import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  preview: {
    open: false,
    type: "workflow",
    page: "",
    data: null,
  },
};

const Assistant = createSlice({
  name: "assistant",
  initialState,
  reducers: {
    setPreviewOpen: (state, action) => {
      return { ...state, preview: { ...state.preview, open: action.payload } };
    },
    setPage: (state, action) => {
      return {
        ...state,
        preview: { ...state.preview, type: "app", page: action.payload },
      };
    },

    setData: (state, action) => {
      return { ...state, preview: { ...state.preview, data: action.payload } };
    },

    setType: (state, action) => {
      return { ...state, preview: { ...state.preview, type: action.payload } };
    },
    resetPreviewState: () => {
      return { ...initialState };
    },
  },
});

export const { setPreviewOpen, setPage, setData, setType, resetPreviewState } = Assistant.actions;

export default Assistant.reducer;
